import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import { useI18n } from '@modules/i18n/composables';
import {
  MIRRORS_LIST_JS_MAIN_ROUTE_NAME,
  MIRRORS_LIST_JS_ROUTE_NAME,
  MIRRORS_LIST_NO_JS_MAIN_ROUTE_NAME,
  MIRRORS_LIST_NO_JS_ROUTE_NAME,
  MIRRORS_LIST_PERMISSIONS,
  TRANSLATION_GROUP_MIRRORS_LIST,
} from '@modules/mirrors-list/constants';
import { MirrorTrackingNamespace } from '@modules/mirrors-list/enums';
import { MirrorsListCreateModule } from '@modules/mirrors-list/submodules/create/MirrorsListCreateModule';
import { MirrorsListEditModule } from '@modules/mirrors-list/submodules/edit/MirrorsListEditModule';
import getTranslationKeys from '@modules/mirrors-list/translations';
import {
  ADMIN_MIRRORS_MENU_ITEM,
  TRANSLATION_GROUP_SIDEBAR,
} from '@modules/sidebar/constants';

export class MirrorsListModule extends AppModule {
  protected submodules = [
    new MirrorsListCreateModule(),
    new MirrorsListEditModule(),
  ];

  addRoutes(router: AppVueRouter): void {
    router.addAdminRoute({
      name: MIRRORS_LIST_JS_MAIN_ROUTE_NAME,
      path: 'mirrors',
      permission: MIRRORS_LIST_PERMISSIONS.SHOW,
      component: () => import('@modules/core/components/SimpleChildRoutePage/SimpleChildRoutePage.vue'),
      keepAliveInclude: 'MirrorsListPage',
    });

    router.addChildRoute(MIRRORS_LIST_JS_MAIN_ROUTE_NAME, {
      name: MIRRORS_LIST_JS_ROUTE_NAME,
      path: ':mirrorsNamespace',
      permission: MIRRORS_LIST_PERMISSIONS.SHOW,
      component: () => import('@modules/mirrors-list/pages/MirrorsListPage/MirrorsListPage.vue'),
    });

    router.addAdminRoute({
      name: MIRRORS_LIST_NO_JS_MAIN_ROUTE_NAME,
      path: 'mirrors',
      permission: MIRRORS_LIST_PERMISSIONS.SHOW,
      component: () => import('@modules/core/components/SimpleChildRoutePage/SimpleChildRoutePage.vue'),
      keepAliveInclude: 'MirrorsListPage',
    });

    router.addChildRoute(MIRRORS_LIST_NO_JS_MAIN_ROUTE_NAME, {
      name: MIRRORS_LIST_NO_JS_ROUTE_NAME,
      path: ':mirrorsNamespace',
      permission: MIRRORS_LIST_PERMISSIONS.SHOW,
      component: () => import('@modules/mirrors-list/pages/MirrorsListPage/MirrorsListPage.vue'),
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_MIRRORS_MENU_ITEM, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'MIRRORS_MIRRORS_LIST_JS'),
      to: {
        name: MIRRORS_LIST_JS_ROUTE_NAME,
        params: {
          mirrorsNamespace: MirrorTrackingNamespace.LIST_JS,
        },
      },
      permission: MIRRORS_LIST_PERMISSIONS.SHOW,
      id: MIRRORS_LIST_JS_ROUTE_NAME,
      order: 10,
    });

    menu.addChildAdminMenuItem(ADMIN_MIRRORS_MENU_ITEM, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'MIRRORS_MIRRORS_LIST_NO_JS'),
      to: {
        name: MIRRORS_LIST_NO_JS_ROUTE_NAME,
        params: {
          mirrorsNamespace: MirrorTrackingNamespace.LIST_NO_JS,
        },
      },
      permission: MIRRORS_LIST_PERMISSIONS.SHOW,
      id: MIRRORS_LIST_NO_JS_ROUTE_NAME,
      order: 20,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_MIRRORS_LIST, getTranslationKeys);
  }
}
